"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "Tab", {
  enumerable: true,
  get: function get() {
    return _Tab.default;
  }
});
_Object$defineProperty(exports, "Tabs", {
  enumerable: true,
  get: function get() {
    return _Tabs.default;
  }
});
var _Tab = _interopRequireDefault(require("./Tab"));
var _Tabs = _interopRequireDefault(require("./Tabs"));
function cov_1up8yd72x0() {
  var path = "/codebuild/output/src3154135081/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Tabs/lib/index.js";
  var hash = "99c61f7bd371cca09a77ff97946003a4d036199b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3154135081/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Tabs/lib/index.js",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "99c61f7bd371cca09a77ff97946003a4d036199b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1up8yd72x0 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1up8yd72x0();